/* eslint-disable  @typescript-eslint/no-explicit-any */
import React from "react";
import { ErrorMessage } from "formik";
import {
  TextInputComponent,
  SelectInputComponent,
  RevenueInputComponent,
  CountryCodeWithPhoneNumber,
} from "../../../../../common/components";
import { MARITAL_STATUS_OPTIONS, RELATIONSHIP_OPTIONS } from "../../../../../constants/leadDropdown";
import leadInfoIcon from "../../../../../assets/icons/leadInfo.svg";
import OwnerIcon from "../../../../../assets/icons/owner.svg";
import "./create-lead-additional-details.scss";

const CreateLeadAdditionalDetails = (props: any) => {
  return (
    <div className="">
      <div className="lead-create-tab-data-section-line-two-ele">
        <div className="lead-create-tab-data-section-line-two-ele-side-one">
          <RevenueInputComponent
            fieldName="leadValue"
            label="Lead Value ($)"
            placeholder="Enter Revenue amount"
            optional={false}
            disabled={false}
            value={props?.values.leadValue}
            onChange={(e) => {
              const input = e.target.value;
              if (/^\d*(\.\d*)?$/.test(input)) {
                props?.setFieldValue("leadValue", input);
              }
            }}
            logo={leadInfoIcon}
          />
        </div>
        <div className="lead-create-tab-data-section-line-two-ele-side-two">
          <div className="lead-create-tab-data-section-line-two-ele-side-two-one">
            <TextInputComponent
              type="text"
              fieldName="age"
              label="Age (years)"
              placeholder="Enter Age (years)"
              optional={false}
              disabled={false}
              value={props?.values.age}
              isName={false}
              allowSpecialCharacters={true}
              onChange={(e: any) =>
                props?.setFieldValue(
                  "age",
                  e?.target?.value
                    ? Number(e?.target?.value) > 0 &&
                      Number(e?.target?.value) <= 120
                      ? e?.target?.value
                      : props?.values.age
                    : "",
                )
              }
            />
          </div>
          <div className="lead-create-tab-data-section-line-two-ele-side-two-one">
            <SelectInputComponent
              fieldName="maritalStatus"
              label="Marital Status"
              options={MARITAL_STATUS_OPTIONS}
              onChange={props?.setMaritalStatus}
              value={props?.maritalStatus}
              placeholder="Select Marital Status"
              icon={OwnerIcon}
            />
          </div>
        </div>
      </div>
      <div className="lead-create-tab-data-section-line-two-ele">
        <div className="lead-create-tab-data-section-line-two-ele-side-one">
          <div className="form-group">
            <CountryCodeWithPhoneNumber
              fieldName="secondaryPhoneNumber"
              label="Secondary Phone Number"
              placeholder={
                props?.values?.secondaryPhoneNumber
                  ? ""
                  : "Enter Secondary Phone Number"
              }
              onChange={(value: string, country: any, one: any, two: any) => {
                const countryCode = country?.dialCode;

                if (!countryCode) {
                  console.warn("Missing dialCode in country object");
                  return;
                }
                if (`+${countryCode}` == two) {
                  props?.setFieldValue("secondaryPhoneNumber", null);
                } else {
                  if (two?.includes(`+${countryCode}`)) {
                    props?.setFieldValue("secondaryPhoneNumber", two);
                  } else {
                    props?.setFieldValue("secondaryPhoneNumber", countryCode);
                  }
                }
              }}
              onBlur={() => {
                props?.setFieldTouched("secondaryPhoneNumber", true);
              }}
              onKeyDown={(value: any) => {
                if (value.location == 0 && value.key == "Backspace") {
                  props?.setFieldValue(
                    "secondaryPhoneNumber",
                    props?.values?.secondaryPhoneNumber?.substring(
                      0,
                      props?.values?.secondaryPhoneNumber?.length,
                    ),
                  );
                }
                if (value.location == 0 && value.key == "Delete") {
                  props?.setFieldValue(
                    "secondaryPhoneNumber",
                    props?.values?.secondaryPhoneNumber?.substring(
                      0,
                      props?.values?.secondaryPhoneNumber?.length,
                    ),
                  );
                }
              }}
              value={props?.values?.secondaryPhoneNumber || "+1"}
              defaultCountry="us"
              optional={true}
              // countryCodeEditable
            />{" "}
            {props?.touched?.secondaryPhoneNumber &&
              props?.touched?.secondaryPhoneNumber && (
                <ErrorMessage
                  name={"secondaryPhoneNumber"}
                  component="div"
                  className="error-message"
                />
              )}
          </div>
        </div>
        <div className="lead-create-tab-data-section-line-two-ele-side-one">
          <TextInputComponent
            type="email"
            fieldName="secondaryEmail"
            label="Secondary Email"
            placeholder="Enter Secondary Email"
            optional={false}
            disabled={false}
            value={props?.values.secondaryEmail}
            onChange={(e: any) =>
              props?.setFieldValue("secondaryEmail", e?.target?.value)
            }
          />
        </div>
      </div>
      <div className="lead-create-tab-data-section-line-two-ele">
        <div className="lead-create-tab-data-section-line-two-ele-side-one">
          <TextInputComponent
            type="Website"
            fieldName="website"
            label="Website"
            placeholder="Enter Website"
            optional={false}
            disabled={false}
            value={props?.values.website}
            onChange={(e: any) =>
              props?.setFieldValue("website", e?.target?.value)
            }
            maxlength="500"
          />
        </div>
        <div className="lead-create-tab-data-section-line-two-ele-side-one">
          <div className="form-group">
            <CountryCodeWithPhoneNumber
              fieldName="fax"
              label="Fax"
              placeholder={props?.values?.fax ? "" : "Enter Fax Number"}
              onChange={(value: string, country: any, one: any, two: any) => {
                const countryCode = country?.dialCode;

                if (!countryCode) {
                  console.warn("Missing dialCode in country object");
                  return;
                }
                if (`+${countryCode}` == two) {
                  props?.setFieldValue("fax", null);
                } else {
                  if (two?.includes(`+${countryCode}`)) {
                    props?.setFieldValue("fax", two);
                  } else {
                    props?.setFieldValue("fax", countryCode);
                  }
                }
              }}
              onKeyDown={(value: any) => {
                if (value.location == 0 && value.key == "Backspace") {
                  props?.setFieldValue(
                    "fax",
                    props?.values?.fax?.substring(
                      0,
                      props?.values?.fax?.length,
                    ),
                  );
                }
                if (value.location == 0 && value.key == "Delete") {
                  props?.setFieldValue(
                    "fax",
                    props?.values?.fax?.substring(
                      0,
                      props?.values?.fax?.length,
                    ),
                  );
                }
              }}
              onBlur={() => {
                props?.setFieldTouched("fax", true);
              }}
              value={props?.values?.fax || "+1"}
              defaultCountry="us"
              optional={true}
              // countryCodeEditable
            />{" "}
            {props?.touched?.fax && props?.touched?.fax && (
              <ErrorMessage
                name={"fax"}
                component="div"
                className="error-message"
              />
            )}
          </div>
        </div>
      </div>
      <div className="lead-create-tab-data-section-line-two-ele">
        <div className="lead-create-tab-data-section-line-two-ele-side-one">
          <TextInputComponent
            type="text"
            label="Industry"
            fieldName="industry"
            value={props?.values.industry}
            placeholder="Enter Industry"
            optional={false}
            disabled={false}
            onChange={(e: any) =>
              props?.setFieldValue("industry", e?.target?.value)
            }
            maxlength="50"
          />
        </div>
        <div className="lead-create-tab-data-section-line-two-ele-side-one">
          <TextInputComponent
            type="text"
            fieldName="designation"
            label="Designation"
            placeholder="Enter Designation"
            optional={false}
            disabled={false}
            value={props?.values.designation}
            onChange={(e: any) =>
              props?.setFieldValue("designation", e?.target?.value)
            }
            maxlength="100"
          />
        </div>
      </div>
      <div className="lead-create-tab-data-section-line-two-ele">
        <div className="lead-create-tab-data-section-line-two-ele-side-one">
          <TextInputComponent
            type="text"
            fieldName="socialLeadId"
            label="Social Lead ID"
            placeholder="Enter Social Lead ID"
            optional={false}
            disabled={false}
            value={props?.values.socialLeadId}
            onChange={(e: any) =>
              props?.setFieldValue("socialLeadId", e?.target?.value)
            }
            maxlength="70"
          />
        </div>
        <div className="lead-create-tab-data-section-line-two-ele-side-one">
          <TextInputComponent
            type="text"
            fieldName="company"
            label="Organisation"
            placeholder="Enter Organisation"
            optional={false}
            disabled={false}
            value={props?.values.company}
            onChange={(e: any) =>
              props?.setFieldValue("company", e?.target?.value)
            }
            maxlength="70"
          />
        </div>
      </div>
      <div className="lead-create-tab-data-section-line-two-ele">
        <div className="lead-create-tab-data-section-line-two-ele-side-one">
          <TextInputComponent
            type="text"
            fieldName="contactPerson"
            label="Contact Person"
            placeholder="Enter Contact Person"
            optional={false}
            disabled={false}
            value={props?.values.contactPerson}
            onChange={(e: any) =>
              props?.setFieldValue("contactPerson", e?.target?.value)
            }
            maxlength="70"
          />
        </div>
        <div className="lead-create-tab-data-section-line-two-ele-side-one">
          <SelectInputComponent
            options={RELATIONSHIP_OPTIONS}
            fieldName="relationship"
            label="Relationship"
            placeholder="Select Relationship"
            optional={false}
            disabled={false}
            value={props?.values.relationship}
            onChange={(e: any) => props?.setFieldValue("relationship", e)}
          />
        </div>
      </div>
      <div className="lead-create-tab-data-section-line-two-ele">
        <div className="lead-create-tab-data-section-line-two-ele-side-one">
          <CountryCodeWithPhoneNumber
            fieldName="contactPersonPhoneNumber"
            label="Contact Person Phone Number"
            placeholder={
              props?.values?.contactPersonPhoneNumber
                ? ""
                : "Enter Contact Person Phone Number"
            }
            onChange={(value: string, country: any, one: any, two: any) => {
              const countryCode = country?.dialCode;

              if (!countryCode) {
                console.warn("Missing dialCode in country object");
                return;
              }
              if (`+${countryCode}` == two) {
                props?.setFieldValue("contactPersonPhoneNumber", null);
              } else {
                if (two?.includes(`+${countryCode}`)) {
                  props?.setFieldValue("contactPersonPhoneNumber", two);
                } else {
                  props?.setFieldValue("contactPersonPhoneNumber", countryCode);
                }
              }
            }}
            onBlur={() => {
              props?.setFieldTouched("contactPersonPhoneNumber", true);
            }}
            onKeyDown={(value: any) => {
              if (value.location == 0 && value.key == "Backspace") {
                props?.setFieldValue(
                  "contactPersonPhoneNumber",
                  props?.values?.contactPersonPhoneNumber?.substring(
                    0,
                    props?.values?.contactPersonPhoneNumber?.length,
                  ),
                );
              }
              if (value.location == 0 && value.key == "Delete") {
                props?.setFieldValue(
                  "contactPersonPhoneNumber",
                  props?.values?.contactPersonPhoneNumber?.substring(
                    0,
                    props?.values?.contactPersonPhoneNumber?.length,
                  ),
                );
              }
            }}
            value={props?.values?.contactPersonPhoneNumber || "+1"}
            defaultCountry="us"
            optional={true}
            // countryCodeEditable
          />
        </div>
      </div>
    </div>
  );
};

export default CreateLeadAdditionalDetails;
